/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';

const WallModel = () => {
    const { gl } = useThree ();

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;
    const railWidth = 0.2;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false    

     

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    let offset;
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanB_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const wallPosOffset = useMemo(() => {
        if(params.backLeanStoragePosition > 0 && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) return railWidth;
        else return 0;
    }, [params.backLeanStoragePosition, params.leanB_p_d, params.add_storage_back])

    // Storage Front Wall - CSG
    const storageFrontWallModelObj = useMemo(() => {
        let mainWall;
        let innerWall;
        let wainscotWall;

        //************************* */ main wall geometry
        let verticalHorizontalPosStorageF = {"x": params.leanB_p_d /-2 + parseInt(params.add_storage_back)+0.01,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : -params.p_d / 2 - 0.15}
        let verticalHorizontalRotStorageF = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLengthStorageF = params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w)) + (params.p_w_c_n ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0)
        let patternDepthStorageF = params.leanB_p_w

        const storageFrontWallModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            storageFrontWallModel.moveTo(-(params.leanB_p_w), 0);
            storageFrontWallModel.lineTo(-(params.leanB_p_w), params.leanB_p_h);
            storageFrontWallModel.lineTo(-(params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst);
            storageFrontWallModel.quadraticCurveTo(
                -(params.leanB_p_w), params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10, 
                -(params.leanB_p_w - const_var.roofRegularDst + 0.1), params.leanB_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pB / 12)
            )
            storageFrontWallModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w) + const_var.roofRegularDst * (2)));
            storageFrontWallModel.lineTo(0, 0);
            storageFrontWallModel.closePath();
        } else {
            storageFrontWallModel.moveTo(-params.leanB_p_w + wallThickness, params.leanB_p_h);
            storageFrontWallModel.lineTo(0, params.leanB_p_h + params.leanB_p_w / 12 * params.b_l_t_r_pB);
            storageFrontWallModel.lineTo(0, 0);
            storageFrontWallModel.lineTo(-params.leanB_p_w + wallThickness, 0);
            storageFrontWallModel.closePath();
        }

        const meshStorageWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthStorageF, isPattern), extrudeSettings(patternDepthStorageF)))  
        const meshBackStorageWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageFrontWallModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshBackStorageInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageFrontWallModel, extrudeSettings(wallThickness)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshBackStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let meshStorageWallModel_Temp = meshStorageWallModel.clone();
        meshStorageWallModel_Temp.position.set(verticalHorizontalPosStorageF.x,verticalHorizontalPosStorageF.y,verticalHorizontalPosStorageF.z);
        meshStorageWallModel_Temp.rotation.set(verticalHorizontalRotStorageF.x,verticalHorizontalRotStorageF.y,verticalHorizontalRotStorageF.z);
        meshStorageWallModel_Temp.updateMatrixWorld();
    
        let meshBackStorageWallModel_Temp = meshBackStorageWallModel.clone();
        meshBackStorageWallModel_Temp.rotateY(-Math.PI / 2);
        meshBackStorageWallModel_Temp.position.set(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + 0.5, 0, -params.p_d / 2 - cbFrontBackWallOffset)
        meshBackStorageWallModel_Temp.updateMatrixWorld();
        
        let meshBackStorageInnerWallModel_Temp = meshBackStorageInnerWallModel.clone();
        meshBackStorageInnerWallModel_Temp.rotateY(-Math.PI / 2);
        meshBackStorageInnerWallModel_Temp.position.set(-params.leanB_p_d / 2 + parseInt(params.add_storage_back), 0, -params.p_d / 2 - cbFrontBackWallOffset)
        meshBackStorageInnerWallModel_Temp.updateMatrixWorld();

        let meshBackStorageDelModel_Temp = meshBackStorageDelModel.clone();
        meshBackStorageDelModel_Temp.rotateY(Math.PI / 2)
        meshBackStorageDelModel_Temp.position.set( parseInt(params.add_storage_back) - 0.5 -params.leanB_p_d / 2, 0, 0);
        meshBackStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos - params.backLeanStoragePosition, 0, -params.p_d / 2 - params.leanB_p_w - 0.95);
        meshSideDelModel_Temp.updateMatrixWorld();
    
        const meshBackStorageWallModel_CSG = CSG.fromMesh(meshBackStorageWallModel_Temp);
        const meshBackStoragInnereWallModel_CSG = CSG.fromMesh(meshBackStorageInnerWallModel_Temp);
        const meshBackStorageDelModel_CSG = CSG.fromMesh(meshBackStorageDelModel_Temp);
        const meshFrontStorageWallModel_CSG = CSG.fromMesh(meshStorageWallModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
    
        const backStorageWallModel_CSG =  meshBackStorageWallModel_CSG.subtract(meshBackStorageDelModel_CSG);
        const backStorageInnerWallModel_CSG =  meshBackStoragInnereWallModel_CSG.subtract(meshBackStorageDelModel_CSG);
        const sideInnerDelModel_CSG =  backStorageInnerWallModel_CSG.subtract(meshSideDelModel_CSG);

        const frontStorageWallModel_CSG = meshFrontStorageWallModel_CSG.intersect(backStorageWallModel_CSG);
        const sideOuterDelModel_CSG = frontStorageWallModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGBackStorageWallModel = CSG.toMesh( sideOuterDelModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const CSGBackStorageInnerWallModel = CSG.toMesh( sideInnerDelModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))
        
        mainWall = CSGBackStorageWallModel.geometry;
        innerWall = CSGBackStorageInnerWallModel.geometry;

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosStorageF = {"x": params.leanB_p_d /-2 + parseInt(params.add_storage_back)+0.01,"y" : 0, "z" : -params.p_d / 2 - 0.15}
        let wainscotVerticalHorizontalRotStorageF = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let lengthPatternStorageF = 3
        let depthPatternStorageF = patternDepthStorageF

        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternStorageF, isPattern), extrudeSettings(depthPatternStorageF)))
        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosStorageF.x,wainscotVerticalHorizontalPosStorageF.y,wainscotVerticalHorizontalPosStorageF.z);
        meshStorageFrontWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotStorageF.x,wainscotVerticalHorizontalRotStorageF.y,wainscotVerticalHorizontalRotStorageF.z);
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        let meshSideWainscotDelModel_Temp = meshSideDelModel.clone();
        meshSideWainscotDelModel_Temp.position.set(-params.leanB_p_pos - params.backLeanStoragePosition, 0, -params.p_d / 2 - params.leanB_p_w - 0.95);
        meshSideWainscotDelModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const sideWainscotDelModel_CSG = CSG.fromMesh(meshSideWainscotDelModel_Temp);

        const storageFrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshBackStorageDelModel_CSG);
        const meshSideWainscotDelModel_CSG = storageFrontWainscotModel_CSG.subtract(sideWainscotDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(
            meshSideWainscotDelModel_CSG,
            new THREE.Matrix4()
        )

        wainscotWall = CSGStorageFrontWainscotModel.geometry;

        return {mainWall, innerWall, wainscotWall}
    }, [params.wallTexture,params.p_b_c_b_b_b, params.p_r_s, params.leanB_p_w, params.backLeanStoragePosition, params.b_l_t_r_pB, params.leanB_p_pos, params.leanB_p_h, params.p_d, params.leanB_p_d, params.p_v_w, params.add_storage_back, const_var.newDoorsArray, params.add_storage_check_back, params.p_w_c_n, isPattern])
   
    return (
        <group position={[wallPosOffset, 0, 0]}>
            {storageFrontWallModelObj?.mainWall &&
                <mesh name="B_L_L_S_W" geometry={storageFrontWallModelObj?.mainWall} position={[offset + 0.02, 0, 0]} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"backLean"} />
                </mesh>
            }
            <group name='in-side-wall'>
                {storageFrontWallModelObj?.innerWall &&
                    <mesh name="storage" geometry={storageFrontWallModelObj?.innerWall} position={[ offset - 0.01, 0, 0]}>
                        <MaterialInnerWall texture={texture} visibleSection={"backLean"} />
                    </mesh>
                }
            </group>
            {/* Storage Front Wainscot */}
            {params.p_w_c_n == true && storageFrontWallModelObj?.wainscotWall &&
                <mesh name="B_L_L_S_W_wainscot" geometry={storageFrontWallModelObj?.wainscotWall} position={[0.025 + offset, 0, 0]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"backLean"} />
                </mesh>
            }
        </group>
    )
}

export default WallModel